import { render } from "./PanelFilter.vue?vue&type=template&id=636ecf6c&scoped=true"
import script from "./PanelFilter.vue?vue&type=script&lang=js"
export * from "./PanelFilter.vue?vue&type=script&lang=js"

import "./PanelFilter.vue?vue&type=style&index=0&id=636ecf6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636ecf6c"]])

export default __exports__